import React from "react";
import MapWithTransferTimes from "./MapWithTransferTimes";

const MapContainer = ({
  stops,
  origin,
  type,
  enablePolyline,
  transferStartFinishTime,
  onOptimize,
  idSuffix,
  savedTotalDistanceKm,
  savedTotalDurationMin,
}) => {
  return (
    <MapWithTransferTimes
      stops={stops}
      origin={origin}
      type={type}
      enablePolyline={enablePolyline}
      transferStartFinishTime={transferStartFinishTime}
      isFullScreen={true}
      idSuffix={idSuffix}
      savedTotalDistanceKm={savedTotalDistanceKm}
      savedTotalDurationMin={savedTotalDurationMin}
      onOptimize={(newStops) => {
        onOptimize(newStops);
      }}
    />
  );
};

export default MapContainer;
